<template>
  <v-flex xs12 sm8 md4>
    <v-layout column align-center fill-height>
      <v-flex style="width:100%;">
        <v-card class="elevation-5">
          <v-card-text>
            <template v-if="$store.state.account">
              <div class="body-2">Продолжить как:</div>
              <v-list two-line>
                <v-list-tile @click="continueLogin">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $store.state.account.userName }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $store.state.account.email }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider></v-divider>
              <div class="body-2" style="margin-top:12px;">Войти с другой учетной записью:</div>
            </template>
            <v-form id="form" ref="form" v-model="formValid">
              <v-text-field autocomplete="new-password" ref="userName" v-model="userName" prepend-icon="mdi-account-outline" name="login" label="Имя пользователя" type="text" :rules="[rules.required]" @input="resetInvalidCredentialsMsg()"></v-text-field>
              <v-text-field autocomplete="new-password" ref="password" v-model="password" prepend-icon="mdi-lock" name="password" label="Пароль" type="password" :rules="[rules.required]" @input="resetInvalidCredentialsMsg()"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <a @click.stop="$router.push('/forgotPassword')" style="margin-left:40px;">Забыли пароль?</a>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat :disabled="!formValid" @click="login">Войти</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex style="margin-top:14px;">
        <span style="margin-right:6px;">Нет учетной записи?</span>
        <a @click.stop="$router.push('/register')">Зарегистрироваться</a>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Rules from "../rules.js"

export default {
  name: 'login',
  data: function() {
    return {
      formValid: false,
      userName: "",
      password: "",
      rules: Rules,
      invalidCredentialsMsg: "Неверные имя пользователя или пароль"
    }
  },
  mounted() {
  },
  methods: {
    resetInvalidCredentialsMsg() {
      if (this.$refs.userName.errorMessages === this.invalidCredentialsMsg) {
        this.$refs.userName.errorMessages = null;
      }
      if (this.$refs.password.errorMessages === this.invalidCredentialsMsg) {
        this.$refs.password.errorMessages = null;
      }
    },
    async login() {
      if (!this.formValid) {
        return;
      }
      let result = await this.$store.dispatch("login", {
        userName: this.userName,
        password: this.password,
      });
      if (result.status === 403) {
        this.$refs.userName.errorMessages = this.invalidCredentialsMsg;
        this.$refs.password.errorMessages = this.invalidCredentialsMsg;
      } else
      if (result.status === 200) {
        await this.continueLogin()
      }
    },
    async continueLogin() {
      if (this.$store.state.loginType === 'responseCode') {
        await this.$store.dispatch('genResponseCode')
      }
      this.$router.push("/");
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Login.vue?94ffdbd0